@import "~@govbr-ds/core/src/components/textarea/textarea";

:host {
  display: inline-block;
  box-sizing: border-box;
  font-family: Rawline, Raleway, sans-serif;
}
